import { S3Client, PutObjectCommand, GetObjectCommand, ListObjectsV2Command } from "@aws-sdk/client-s3";

// Bereinige den Endpunkt (entferne eventuelle Trailing-Slashes für die SDK-Kompatibilität)
const rawEndpoint = import.meta.env.VITE_S3_ENDPOINT || "";
const cleanEndpoint = rawEndpoint.endsWith('/') ? rawEndpoint.slice(0, -1) : rawEndpoint;

const s3Client = new S3Client({
  endpoint: cleanEndpoint,
  region: import.meta.env.VITE_S3_REGION || "us-east-1",
  credentials: {
    accessKeyId: import.meta.env.VITE_S3_ACCESS_KEY,
    secretAccessKey: import.meta.env.VITE_S3_SECRET_KEY,
  },
  forcePathStyle: true, // Zwingend erforderlich für MinIO (URL/bucket statt bucket.URL)
});

const DEFAULT_BUCKET = import.meta.env.VITE_S3_BUCKET || "grt-crm";

export const s3Service = {
  async uploadJson(path, data, bucketName = null) {
    const bucket = bucketName || DEFAULT_BUCKET;
    const json = JSON.stringify(data, null, 2);
    
    console.log('📤 S3 Upload:', {
      bucket,
      path,
      endpoint: cleanEndpoint,
      dataSize: json.length
    });
    
    const command = new PutObjectCommand({
      Bucket: bucket,
      Key: path,
      Body: json,
      ContentType: "application/json"
    });
    
    return await s3Client.send(command);
  },

  async downloadJson(path, bucketName = null) {
    const bucket = bucketName || DEFAULT_BUCKET;
    const url = `${cleanEndpoint}/${bucket}/${path}`;
    
    console.log('🔍 S3 Download CORS-Test:', {
      bucket,
      path,
      url,
      endpoint: cleanEndpoint
    });
    
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
        mode: 'cors',
      });

      console.log('✅ Response Status:', response.status);
      console.log('📋 Response Headers:', [...response.headers.entries()]);
      console.log('🎯 CORS-Header (Access-Control-Allow-Origin):', response.headers.get('Access-Control-Allow-Origin'));
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const text = await response.text();
      console.log('📦 Response Body (first 200 chars):', text.substring(0, 200));
      
      return JSON.parse(text);
    } catch (error) {
      console.error('❌ S3 Download fehlgeschlagen:', error);
      console.error('🔧 Error Details:', {
        name: error.name,
        message: error.message,
        stack: error.stack
      });
      throw error;
    }
  },

  async listFiles(prefix, bucketName = null) {
    const bucket = bucketName || DEFAULT_BUCKET;
    const command = new ListObjectsV2Command({
      Bucket: bucket,
      Prefix: prefix
    });
    const response = await s3Client.send(command);
    return response.Contents || [];
  }
};